/* eslint-disable eqeqeq */
import React from 'react'
import AnnouncementIcon from '@material-ui/icons/Announcement';
import { Alert, AlertTitle } from '@material-ui/lab';
import ModalEdit from '../../../components/master/SegmentacionModal/Modal'
import CardTitle from '../../../components/sharedComponents/CardTitle'
import PolygonsTable from '../../../components/sharedComponents/Tablas/index';
import { permitsList } from '../../../constants/permits'

const SegmentacionPage = props => {
  const {
    onChangeInputSelector,
    handleClickOpen,
    subcategorias,
    segmentacion,
    handleClose,
    handleUpdate,
    subsegmetos,
    categorias,
    segmentos,
    empresas,
    values,
    paises,
    open,
    show,
  } = props

  const columns = [
    {
      title: 'Estado',
      field: 'estado',
      render: (rowData) =>
        rowData.categoria == 'No asignado' ? (
          <AnnouncementIcon
            style={{
              color: !rowData.servicio ? '#851A30' : rowData.servicio,
              width: '20px',
              height: '18px',
            }}
          />
        ) : (
          <AnnouncementIcon
            style={{
              color: !rowData.servicio ? '#002D74' : rowData.servicio,
              width: '20px',
              height: '18px',
            }}
          />
        ),
    },
    { title: 'Und', field: 'unidades', editable: 'never' },
    { title: 'Empresa', field: 'empresa', editable: 'never' },
    { title: 'Cod', field: 'ensambladora', editable: 'never' },
    { title: 'Marca', field: 'marca', editable: 'never' },
    { title: 'Linea', field: 'linea', editable: 'never' },
    { title: 'Carroceria', field: 'carroceria', editable: 'never' },
    { title: 'Combustible', field: 'combustible', editable: 'never' },
    { title: 'Clase', field: 'clase', editable: 'never' },
    { title: 'Categoría', field: 'categoria' },
    { title: 'SubCatg', field: 'subcategoria' },
    { title: 'Segmento', field: 'segmento' },
    { title: 'Origen', field: 'pais' },
    { title: 'SubSegmet', field: 'subsegmento' },
  ]

  return (
    <>
      <CardTitle title="Tabla de segmentación" />
      {show && (
        <Alert
          style={{ margin: '10px' }}
          onClose={handleClose}
          severity="warning"
        >
          <AlertTitle>Info</AlertTitle>
          <li>
            <strong>***</strong> No se cuenta el código de la ensambladora y se
            puede segmentar como normalmente se hace
          </li>
          <li>
            <strong>---</strong>
            Se tiene en cuenta el código de la ensambladora, pero no se dispone
            del mismo en la información del runt.
          </li>
          <li>
            <strong> 9FL, 9GP, ZBN</strong> Se tiene en cuenta el código de la
            ensambladora
            <ol>
              - Mobility es <strong>9GF</strong>
            </ol>
            <ol>
              - Benelli es <strong>9FG</strong>
            </ol>
            <ol>
              - <strong>ZBN</strong> Ensamble otras empresas
            </ol>
          </li>
        </Alert>
      )}
      <PolygonsTable
        idPermisoTabla={permitsList.SEGMENTACION_MAESTROS_SEGMENTOS}
        onClickEdit={handleClickOpen}
        titleTable="Filtre y edite"
        dataTable={segmentacion}
        hiddenEdit={false}
        actionsColumn={1}
        columns={columns}
        hiddenDelete
      />
      <ModalEdit
        open={open}
        seg4w={false}
        paises={paises}
        update={values}
        empresas={empresas}
        segmentos={segmentos}
        categorias={categorias}
        subsegmetos={subsegmetos}
        handleUpdate={handleUpdate}
        handleClose={handleClose}
        subcategorias={subcategorias}
        onChangeInputSelector={onChangeInputSelector}
      />
    </>
  )

}

export default SegmentacionPage;
